var _path, _g, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10737_7585",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 12,
    width: 14,
    height: 7
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33337 12.0801H16.5333V18.2251H3.33337V12.0801Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10737_7585)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.93409 13.3301C6.38325 13.3301 4.58325 13.9401 4.58325 15.1442C4.58325 16.3592 6.38325 16.9751 9.93409 16.9751C13.4841 16.9751 15.2833 16.3651 15.2833 15.1609C15.2833 13.9459 13.4841 13.3301 9.93409 13.3301ZM9.93409 18.2251C8.30159 18.2251 3.33325 18.2251 3.33325 15.1442C3.33325 12.3976 7.10075 12.0801 9.93409 12.0801C11.5666 12.0801 16.5333 12.0801 16.5333 15.1609C16.5333 17.9076 12.7666 18.2251 9.93409 18.2251Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_10737_7585",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 1,
    width: 10,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5083 1.66699H14.3583V10.5158H5.5083V1.66699Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_10737_7585)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.93416 2.85699C8.14999 2.85699 6.69833 4.30783 6.69833 6.09199C6.69249 7.87033 8.13333 9.32032 9.90999 9.32699L9.93416 9.92199V9.32699C11.7175 9.32699 13.1683 7.87533 13.1683 6.09199C13.1683 4.30783 11.7175 2.85699 9.93416 2.85699ZM9.93416 10.5162H9.90749C7.47249 10.5087 5.49999 8.52283 5.50833 6.08949C5.50833 3.65199 7.49333 1.66699 9.93416 1.66699C12.3742 1.66699 14.3583 3.65199 14.3583 6.09199C14.3583 8.53199 12.3742 10.5162 9.93416 10.5162Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersons);
export default __webpack_public_path__ + "static/media/persons.9b38297e3be08f943c4ee51138f09781.svg";
export { ForwardRef as ReactComponent };